<template>
    <div class="content">
        <Introduction></Introduction>
        <Process></Process>
        <Design></Design>
        <Gallery></Gallery>
    </div>
</template>

<script>
    import Introduction from "@/components/Home/Introduction";
    import Process from "@/components/Home/Process";
    import Design from "@/components/Home/Design";
    import Gallery from "../components/Home/Gallery";
    export default {
        name: 'home',
        components: {Gallery, Process, Design, Introduction}
    }
</script>

<style>
    .content {
        flex: 0 1;
        max-width: 1000px;
    }
</style>
